<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { getHealth } from '../services/api'

const status = ref<string>('loading')
const uptime = ref<number | null>(null)
const error = ref<string | null>(null)

async function checkHealth() {
  status.value = 'loading'
  error.value = null
  try {
    const data = await getHealth()
    status.value = data.status
    uptime.value = data.uptime
  } catch (e) {
    status.value = 'error'
    error.value = 'Backend unreachable'
  }
}

// 5567 -> "1h 32m"; 93177 -> "1d 1h"; 45 -> "<1m"
function formatUptime(seconds: number): string {
  const d = Math.floor(seconds / 86400)
  const h = Math.floor((seconds % 86400) / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  if (d > 0) return `${d}d ${h}h`
  if (h > 0) return `${h}h ${m}m`
  return m > 0 ? `${m}m` : '<1m'
}

onMounted(() => {
  checkHealth()
})
</script>

<template>
  <div class="text-sm bg-cc-elevated p-4 rounded-lg shadow-sm border border-cc-border flex items-center gap-4">
    <div class="font-bold text-cc-text">System Status:</div>
    <div v-if="status === 'loading'" class="text-cc-text-tertiary">Checking...</div>
    <div v-else-if="status === 'ok'" class="text-cc-success flex items-center gap-2">
      <span class="w-2 h-2 rounded-full bg-cc-success"></span>
      <span>Operational</span>
      <span v-if="uptime !== null" class="text-cc-text-secondary font-normal">· up {{ formatUptime(uptime) }}</span>
    </div>
    <div v-else class="text-red-600 font-medium">
      {{ error }}
      <button @click="checkHealth" class="ml-2 text-blue-600 underline text-xs">Retry</button>
    </div>
  </div>
</template>
